import React from "react";
import { Box, Typography } from "@mui/material";
import IconCircle from "../shared/IconCircle";
import { CONTENT_MAX_WIDTH, cardDescSx, cardTitleSx } from "../shared/styles";
import { LaptopIcon } from "./icons";
import { MAX_SESSIONS } from "./sessionUtils";

function SessionLimitBanner({ sessionCount }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        height: 80,
        mt: "32px",
        p: "16px",
        borderRadius: "8px",
        border: "1px solid #FFD591",
        bgcolor: "#FFF7E6",
        boxSizing: "border-box",
      }}
    >
      <IconCircle bgcolor="#FFE7BA" sx={{ width: 48, height: 48 }}>
        <LaptopIcon color="#AD4E00" />
      </IconCircle>
      <Box>
        <Typography component="p" sx={cardTitleSx}>
          Session Limit
        </Typography>
        <Typography component="p" sx={{ ...cardDescSx, mt: "4px" }}>
          Maximum {MAX_SESSIONS} concurrent sessions allowed. Currently using{" "}
          {sessionCount} of {MAX_SESSIONS} sessions.
        </Typography>
      </Box>
    </Box>
  );
}

export default SessionLimitBanner;
